import { styled } from '@mui/material'
import TextInput from '../../../../../../../../components/editors/input/TextInput'
import { colorPalette } from '../../../../../../../../style/colorPalette'

export const ConfigContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '16px',
})

export const SectionContent = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  overflowY: 'auto',
})

/**
 * ページタイトルの節。スクロール領域（SectionContent）の外に置き、
 * 集計対象を選んでいる間もタイトルが常に見えるようにする。
 * 外に出すぶん、下の節との間隔を自分で持つ
 */
export const PageTitleSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flexShrink: 0,
  marginBottom: '20px',
})

export const FormSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

export const FormLabel = styled('label')({
  fontSize: '14px',
  fontWeight: 500,
  color: colorPalette.monotone[10],
  marginBottom: '4px',
})

export const EmptyConfigContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: colorPalette.monotone[1],
})

export const EmptyConfigText = styled('span')({
  fontSize: '14px',
  color: colorPalette.monotone[4],
  textAlign: 'center',
})

/**
 * ページタイトル入力欄の marginTop。
 * 横に並ぶページタイトル候補（PageTitleSuggestionButton）が枠の位置をここに合わせるため、
 * 値を共有して片方だけ動かないようにしている
 */
export const PAGE_TITLE_INPUT_MARGIN_TOP = 8

export const PageTitleInput = styled(TextInput)({
  width: '50%',
  maxWidth: '400px',
  marginTop: `${PAGE_TITLE_INPUT_MARGIN_TOP}px`,
})
